/* eslint-disable no-return-assign */
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable  react/self-closing-comp */

import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { VeoliaInput, VeoliaButton } from '@veolia.com/vds-react-components';
import { Backdrop, CircularProgress, Grid, Typography, Checkbox, Link, Divider } from '@mui/material';
import { useOidc } from '@axa-fr/react-oidc';
import { useNavigate } from 'react-router-dom';
import columnDefs from '../../column-defs';
import * as validation from '../../shared/validation';
import '../../styles/login.scss';
import {externalApprovedUser} from '../../shared/api/url-helper';
import { signup_background, veolia_header } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import Footer from '../layout/footer';
import { getDecryptedLoginUsers } from './user';

const SignIn = () => {
  const { isAuthenticated, logout } = useOidc();
  const [loading, setLoading] = useState(false);
  const [authData, setAuthData] = useState({});
  const [rememberMe, setRememberMe] = useState(false);

  const getApprovedLoginUsers = () => {
    const users = [];

    const isApprovedStatus = (statusValue) => {
      const normalized = (statusValue || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, '');
      return normalized === 'approved' || normalized === 'autoapproved';
    };

    const pushUser = (emailValue, passwordValue) => {
      const emailTrimmed = (emailValue || '').toString().trim();
      const passwordString = (passwordValue || '').toString();
      if (!emailTrimmed || !passwordString) return;
      const emailNormalized = emailTrimmed.toLowerCase();
      if (users.some((u) => u.email === emailNormalized)) return;
      users.push({ email: emailNormalized, password: passwordString });
    };

    const decryptedUsers = getDecryptedLoginUsers();
    if (Array.isArray(decryptedUsers)) {
      decryptedUsers.forEach((u) => {
        if (!u || typeof u !== 'object') return;
        if (!isApprovedStatus(u.status)) return;
        pushUser(u.email, u.password);
      });
    }

    return users;
  };
  // @sudarsana useState hooks for new login page
  const [customerRadioValue, setCustomerRadioValue] = useState(1); // Default value set to 1
  const [externalRadioValue, setExternalRadioValue] = useState(null);
  const [customerData, setCustomerData] = useState(false);
  const [LoginFormRight, setLoginFormRight] = useState(true);
  const [values] = React.useState({
    showPassword: false
  });

  // added by abhishek on 16-12-24 -> Object to store user location
  // capturing his/her ip address, city, state & country
  const [ipInfo, setIpInfo] = useState({
    publicIP: null,
    city: null,
    region: null,
    country: null,
    error: null,
  });

  // validation layer start
  const navigate = useNavigate();
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [touchedFields, setTouchedFields] = useState({});
  const { schema } = columnDefs.login.forms;
  const { password, email } = authData;
  const errors = validation.validation({
    schema,
    data: {
      password,
      email,
    },
  });
  const handleBlur = (e, name) => {
    const { id } = e.target;
    setTouchedFields({
      ...touchedFields,
      [name || id]: true,
    });
  };
  const validationDiv = (field) =>
    validation.errorDiv(errors, touchedFields, field);
  // validation layer end
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      type
    });
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      // China-only bypass: allow a small list of pre-configured users (from ./user)
      // to bypass the external approval API. Only users with status Approved/Auto Approved are allowed.
      // If no match, we fall back to externalApprovedUser.
      // Keep the same China-domain detection logic as before.
      const isChinaOrLocal = window.location.href.includes('https://winflows.watertechs.cn');

      if (isChinaOrLocal) {
        const approvedUsers = getApprovedLoginUsers();
        const inputEmail = (authData?.email || '').toString().trim().toLowerCase();
        const inputPassword = (authData?.password || '').toString();

        if (approvedUsers.length > 0) {
          // If credentials match one of the configured users, treat as authenticated and skip API call.
          const matched = approvedUsers.some((u) => u.email === inputEmail && u.password === inputPassword);
          if (matched) {
            // Build a minimal session object for the UI.
            const loginInfo = {
              isAuthenticated: true,
              // Keep the original casing the user typed for display.
              email: authData.email,
              // Track when this login happened (useful for troubleshooting).
              lastUpdate: new Date().toISOString()
            };
            // Persist the login session data.
            localStorage.setItem('LoginUser', JSON.stringify(loginInfo));
            // Session is valid for 6 hours.
            const sessionDuration = 6 * 60 * 60 * 1000;
            // Compute absolute expiration timestamp.
            const expiresAt = new Date().getTime() + sessionDuration;
            // Store expiration timestamp used elsewhere for session checks.
            sessionStorage.setItem('expTime', expiresAt.toString());
            if (rememberMe) {
              // If Remember Me is checked, store credentials in cookies for 7 days.
              Cookies.set('username', authData.email, { expires: 7 });
              Cookies.set('password', authData.password, { expires: 7 });
            } else {
              // Otherwise ensure any previously stored cookies are removed.
              Cookies.remove('username');
              Cookies.remove('password');
            }
            // Redirect on successful login.
            navigate('/recent-files-list');
            // Important: return here so we do NOT call the backend approval API.
            return;
          }
        }
      }

      // Default path: verify user via backend approval service.
      const response = await externalApprovedUser({ email: authData.email, password: authData.password });
      const usersData = response.data;

      if (usersData.status === 'approved') {
        // Backend approved: create a session object.
        const loginInfo = {
          isAuthenticated: true,
          // Email returned/used for the session.
          email: authData.email
        };
        // Session is valid for 6 hours.
        const sessionDuration = 6 * 60 * 60 * 1000; // 6 hours in milliseconds
        // Compute absolute expiration timestamp.
        const expiresAt = new Date().getTime() + sessionDuration;
        // Persist login info to localStorage.
        localStorage.setItem('LoginUser', JSON.stringify(loginInfo));
        // Persist expiration time to sessionStorage.
        sessionStorage.setItem('expTime', expiresAt.toString());
        if (rememberMe) {
          // Remember credentials for 7 days.
          Cookies.set('username', authData.email, { expires: 7 });
          Cookies.set('password', authData.password, { expires: 7 });
        } else {
          // Clear any remembered credentials.
          Cookies.remove('username');
          Cookies.remove('password');
        }
        // Redirect on successful login.
        navigate('/recent-files-list');
      } else {
        // Backend responded but user is not approved.
        openModelPopUp('Invalid email or password.', 'error', 'error');
      }
    } catch (error) {
      console.error('API request failed:', error);
      openModelPopUp('Invalid email or password.', 'Error', 'error');
    } finally {
      setLoading(false);
    }
  };
  const Authenticate = () => {
    localStorage.setItem('Authenticate', true);
  };
  const handleChange = (e, name) => {
    const { value } = e.target;
    setAuthData({ ...authData, [name]: value });
  };
  const handleCheckboxChange = (event) => {
    setRememberMe(event.target.checked);
  };

  // to get the user location from IP address -> By Abhishek on 12-12-2024 - start
  const getPublicIP = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching public IP:', error);
      return null;
    }
  };

  // function to get the user's location based on his/her ip-address
  const getLocation = async (ip) => {
    try {
      const response = await fetch(`http://ip-api.com/json/${ip}`);
      const data = await response.json();
      if (data.status === 'success') {
        return {
          city: data.city,
          region: data.regionName,
          country: data.country
        };
      }
      return null;
    } catch (error) {
      console.error('Error fetching location:', error);
      return null;
    }
  };
  // to get the user location from IP address -> By Abhishek on 12-12-2024 - end

  // update the state after getting user's location
  const fetchIPInfo = async () => {
    const publicIP = await getPublicIP();
    if (publicIP) {
      setIpInfo(prevState => ({ ...prevState, publicIP }));

      const location = await getLocation(publicIP);
      if (location) {
        setIpInfo(prevState => ({
          ...prevState,
          ...location
        }));
      } else {
        setIpInfo(prevState => ({
          ...prevState,
          error: 'Location information not found.'
        }));
      }
    } else {
      setIpInfo(prevState => ({
        ...prevState,
        error: 'Failed to retrieve public IP address.'
      }));
    }
  };

  useEffect(async () => {
    if (localStorage.getItem('appWiz')) {
      localStorage.removeItem('appWiz');
    }
    if (sessionStorage.getItem('sessionWarningShown')) {
      sessionStorage.removeItem('sessionWarningShown');
    }
    if (localStorage.getItem('i18nextLng') && Cookies.get('language_selection') != null) {
      localStorage.setItem('i18nextLng', Cookies.get('language_selection'));
    }
    if (isAuthenticated) {
      logout();
    }

    const savedUsername = Cookies.get('username');
    const savedPassword = Cookies.get('password');
    if (savedUsername && savedPassword) {
      setAuthData({ email: savedUsername, password: savedPassword });
      setRememberMe(true);
    }
    fetchIPInfo();
  }, []);

  useEffect(() => {
    if (ipInfo.country === 'China') {
      // Changed to read China sign-in URL from env configuration.
      window.location.href = process.env.REACT_APP_CHINA_SIGN_IN_URL; // redirect to China URL
    }
  }, [ipInfo]);
  // sudarsana handleCustomerRadioChange changes
  const handleCustomerRadioChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setCustomerRadioValue(value);
    setExternalRadioValue(null); // Uncheck external radio group

    if (value === 1 || value === 2) {
      setCustomerData(false);
    }
    if (value === 1) {
      setLoginFormRight(true);
    }
    if (value === 2) {
      setLoginFormRight(false);
    }
  };
  // sudarsana handleExternalRadioChange changes
  const handleExternalRadioChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setExternalRadioValue(value);
    setCustomerRadioValue(null); // Uncheck customer radio group

    if (value === 3 || value === 4) {
      setCustomerData(true);
      setLoginFormRight(true);
    }
  };
  return (
    <div>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        style={{
          background: '#d9dbde5c',
        }}>
        <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
      </Backdrop>
      <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
      <img src={signup_background}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
      <img className='h-100' align="left" src={veolia_header}
        style={{ marginLeft: '48px', height: '40px', marginTop: '24px', position: 'relative', zIndex: 1, marginBottom: '11px' }} />
      <div>
        <p style={{ fontSize: '32px', marginLeft: '48px', width: '143px', height: '120px', position: 'relative', zIndex: 1, color: '#FFFFFF' }}>Winflows Design Simulator</p>
      </div>

      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1, minWidth: '65%' }}>
        <div className='sign-up-mainpage'>
          <div className='sign-up-outer' style={{ alignItems: 'center' }}>
            <div className='winflowDesign'>Select an option below to login</div>
            <Grid container style={{ display: 'flex' }} spacing={1}>
              <Grid item xs={12} md={5.5} sx={{ m: { xs: '10px 0px 10px 0px', md: '10px 25px 10px 0px' } }}
                style={{
                  padding: '8px',
                  //  borderRadius: '8px',
                  // backgroundImage: 'linear-gradient(134.67deg, #002D62 -3.85%, #0679CC 69.7%)',
                  display: 'flex',
                  flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'
                }}>
                <div style={{
                  // backgroundImage: 'linear-gradient(134.67deg, #002D62 -3.85%, #0679CC 69.7%)',
                  //  borderRadius: '8px'
                }}>
                  <div style={{
                    fontSize: '16px', fontWeight: 700, lineHeight: '24px', textAlign: 'left', color: '#1C1C1F',
                    // color: '#FFFFFF',
                    //  marginBottom: '16px'
                    fontFamily: 'TheSans Veolia'
                  }}>
                    Veolia Employees
                  </div>
                  {/* <Link href="/" variant="body2" className="" onClick={Authenticate} style={{ textDecoration: 'none' }}>
                    <Tooltip title='Veolia - WTZ Employees' placement="right" arrow>
                      <VeoliaButton className="full-width" htmlType="button"
                        icon={<img style={{ display: 'inline-block', marginRight: '26.67px', height: '13.87px' }} src={White_logo} />}
                        iconPosition="right" size="default" variant="tertiary">
                        WTZ
                      </VeoliaButton>
                    </Tooltip>
                  </Link> */}
                  <div className='veolia_radios' style={{ marginTop: '8px' }}>
                    <div className="veolia-radio-group vertical">
                      <label htmlFor="veolia-radio-singleton-0" className="veolia-radio">
                        <input
                          name="veolia-radio-group-0"
                          type="radio"
                          id="veolia-radio-singleton-0"
                          value={1}
                          checked={customerRadioValue === 1}
                          onChange={handleCustomerRadioChange}
                        />
                        Water Technologies Employees
                        <span aria-hidden="true" className="checkmark"></span>
                      </label>
                      <label htmlFor="veolia-radio-singleton-1" className="veolia-radio">
                        <input
                          name="veolia-radio-group-0"
                          type="radio"
                          id="veolia-radio-singleton-1"
                          value={2}
                          checked={customerRadioValue === 2}
                          onChange={handleCustomerRadioChange}
                        />
                        Non - Water Technologies Employees
                        <span aria-hidden="true" className="checkmark"></span>
                      </label>
                    </div>
                  </div>

                  <div style={{
                    marginTop: '8px',
                    fontSize: '16px', fontWeight: 700, lineHeight: '24px', textAlign: 'left', color: '#1C1C1F',
                    fontFamily: 'TheSans Veolia'
                  }}>
                    External Users
                  </div>

                  <div className='external_radios' style={{ marginTop: '8px' }}>
                    <div className="veolia-radio-group vertical">
                      <label htmlFor="veolia-radio-singleton-2" className="veolia-radio">
                        <input
                          name="veolia-radio-group-1"
                          type="radio"
                          id="veolia-radio-singleton-2"
                          value={3}
                          checked={externalRadioValue === 3}
                          onChange={handleExternalRadioChange}
                        />
                        Customer*
                        <span aria-hidden="true" className="checkmark"></span>
                      </label>
                      <label htmlFor="veolia-radio-singleton-3" className="veolia-radio">
                        <input
                          name="veolia-radio-group-1"
                          type="radio"
                          id="veolia-radio-singleton-3"
                          value={4}
                          checked={externalRadioValue === 4}
                          onChange={handleExternalRadioChange}
                        />
                        Distributor / Channel Partner*
                        <span aria-hidden="true" className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div style={{ height: '77px', marginTop: '8px' }}>
                    {customerData &&
                      <div className='customerParagraph'>
                        {`*${externalRadioValue === 4 ? 'Distributor / Channel Partner' : 'Customers'} can login with their username and password (e.g., eStore login). To register, select the “${externalRadioValue === 4 ? 'Distributor / Channel Partner' : 'Customers'}” login option, enter your email, and then click “Register now”. You will need your 10-digit account number to complete the registration process.`}
                      </div>
                    }
                  </div>

                  <div className='customerParagraph_contactQuery'>
                    For any queries contact:<span className='customerParagraph_contactQuery1'> winflows_support@veolia.com</span>
                  </div>

                </div>
              </Grid>
              {/* <VeoliaDivider orientation="vertical" variant="light" style={{ display: { xs: 'none', md: 'block' } }} /> */}
              <Divider style={{ borderWidth: 1 }} />
              {LoginFormRight ? (<>
                <Link href="/" variant="body2" className="LoginLinkNavigation" onClick={Authenticate} style={{ textDecoration: 'none', margin: 'auto', height: '230px' }}>
                  <div className='veolia_button'>

                    <VeoliaButton htmlType="button"
                      iconPosition="center" size="default" variant="tertiary"
                    //  onMouseEnter={(e) => e.currentTarget.textContent = 'Veolia'}
                    //  onMouseLeave={(e) => e.currentTarget.textContent = 'Estore ID'}
                    >
                      Login
                    </VeoliaButton>

                  </div>
                </Link>
              </>) : (
                <Grid item xs={12} md={5} sx={{ ml: { xs: 0, md: '25px' } }} style={{}}>
                  {/* <Grid item style={{ marginTop: '10px', fontSize: '16px', fontWeight: 700, lineHeight: '24px', color: '#1C1C1F', textAlign: 'left' }} >
                  Outside WTZ Veolia Employees
                </Grid> */}
                  <Grid item xs={12} style={{ marginTop: '8px' }} className="rufusReg f14 mx-100 ">
                    <p className='text-label-signup L_Regular' style={{ marginBottom: '8px' }}>Email ID</p>
                    <VeoliaInput
                      id="outlined-basic"
                      onChange={(e) => handleChange(e, 'email')}
                      onBlur={(e) => handleBlur(e, 'email')}
                      value={email}
                      className='bordered-input M_Regular'
                      placeholder='Enter your Email here'
                      type="text"
                      variant="dark"
                      size="large"
                      autocomplete="username"
                      status={validationDiv('email') ? 'error' : 'default'}
                    />
                    <div style={{ textAlign: 'left' }}>{validationDiv('email')}</div>
                  </Grid>
                  <Grid item xs={8} style={{ marginTop: '16px' }} className="rufusReg f14 mx-100 ">
                    <p className='text-label-signup L_Regular' style={{ marginBottom: '8px' }}>Password</p>
                    <VeoliaInput
                      id="outlined-adornment-password"
                      type={values.showPassword ? 'text' : 'password'}
                      value={password}
                      placeholder='Enter your Password here'
                      onChange={(e) => handleChange(e, 'password')}
                      onBlur={(e) => handleBlur(e, 'password')}
                      className='bordered-input M_Regular'
                      variant="dark"
                      size="large"
                      autocomplete="current-password"
                      status={validationDiv('password') ? 'error' : 'default'}
                    />
                  </Grid>
                  <div style={{ textAlign: 'left' }}>{validationDiv('password')}</div>
                  <Grid item style={{ paddingTop: '8px' }}>
                    <div className="rem_pass">
                      <div className="remember sansW4SeLig">
                        <Checkbox
                          name="checkedB"
                          color="default"
                          data-testid="input-checkbox"
                          size="small"
                          checked={rememberMe}
                          onChange={handleCheckboxChange} />
                        <Typography className="rem_class" style={{ marginLeft: '8px' }}>Remember Me</Typography>
                      </div>
                      <div className="text-sm">
                        {/* <a href="/forgot-password" data-testid="a-link" */}
                        <a data-testid="a-link" href="/reset_pwd"
                          className="link-text sansW6SeBld S_Regular">Reset Password?</a>
                      </div>
                    </div>
                  </Grid>
                  <Grid item style={{ marginTop: '16px' }}>
                    <VeoliaButton className="full-width" htmlType="button" onClick={handleSubmit}
                      iconPosition="right" size="default" variant="tertiary">
                      Login
                    </VeoliaButton>
                  </Grid>
                  <Grid item style={{ marginTop: '8px', textAlign: 'center', fontSize: '16px', fontWeight: 500, lineHeight: '24px', color: '#1C1C1F' }} >
                    <p className="">Not registered yet? Then
                      <a href="/sign-up" className="link-text B_Regular" sx={{ paddingLeft: '8px' }}>Sign Up</a></p>
                  </Grid>
                </Grid>
              )
              }
              <Grid item xs={12} style={{ marginTop: '16px' }}>
                {/* <Typography
                  variant="body2"
                  align="center"
                  className="footerLogin M_Regular forground-text-secondary-WithoutHover">
                  ©2024 Veolia. All rights reserved. <span style={{ fontWeight: 700 }}>Powered by</span>
                  <img style={{ marginLeft: '8px' }} src={sign_logo_icon} />
                </Typography> */}
                <Footer />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SignIn;
